import React, {useState, useEffect} from 'react';
import {t} from 'react-switch-lang';
import {NavLink} from 'react-router-dom';
import roles from '../../../utils/roles';
import {useUserContext} from '../../../contexts/UserContext';

const Administration = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  const user = useUserContext();

  const userRoles = user.authorities;

  const difUserRoles = (array) => {
    const result = array.filter((element) => userRoles.includes(element));

    return result.length > 0;
  };

  useEffect(() => {
    if (Array.isArray(userRoles)) {
      setIsLoaded(true);
    }
  }, [userRoles]);

  const navigation = [
    {
      name: t('administration.users'),
      link: '/users',
      tooltip: t('administration.users'),
      role: [roles.role_admin, roles.role_super_admin],
    },
    {
      name: t('financialPerformances.financialPerformances'),
      link: '/financial-performances',
      tooltip: t('financialPerformances.financialPerformances'),
      role: [roles.role_super_admin, roles.role_technological],
    },
    {
      name: t('frequencyOccurenceRisks.frequencyOccurenceRisks'),
      link: '/frequency-occurence-risks',
      tooltip: t('frequencyOccurenceRisks.frequencyOccurenceRisks'),
      role: [roles.role_super_admin, roles.role_technological],
    },
    {
      name: t('sidebar.departments'),
      link: '/departments',
      tooltip: t('sidebar.departments'),
      role: [
        roles.role_admin,
        roles.role_super_admin,
        roles.role_technological,
      ],
    },
    {
      name: t('departmentType.departmentTypes'),
      link: '/department-types',
      tooltip: t('departmentType.departmentTypes'),
      role: [roles.role_technological, roles.role_super_admin],
    },
    {
      name: t('costEstimations.costEstimations'),
      link: '/cost-estimations',
      tooltip: t('costEstimations.costEstimations'),
      role: [roles.role_super_admin, roles.role_technological],
    },
    {
      name: t('courtCategoryRisks.courtCategoryRisks'),
      link: '/court-category-risks',
      tooltip: t('courtCategoryRisks.courtCategoryRisks'),
      role: [roles.role_super_admin, roles.role_technological],
    },
    {
      name: t('courtSubcategoryRisks.courtSubcategoryRisks'),
      link: '/court-subcategory-risks',
      tooltip: t('courtSubcategoryRisks.courtSubcategoryRisks'),
      role: [roles.role_super_admin, roles.role_technological],
    },
    {
      name: t('riskCategories.riskCategories'),
      link: '/risk-categories',
      tooltip: t('riskCategories.riskCategories'),
      role: [roles.role_super_admin, roles.role_technological],
    },
    {
      name: t('riskCauses.riskCauses'),
      link: '/risk-causes',
      tooltip: t('riskCauses.riskCauses'),
      role: [roles.role_super_admin, roles.role_technological],
    },
    {
      name: t('subRisksCauses.subRisksCauses'),
      link: '/risk-sub-causes',
      tooltip: t('subRisksCauses.subRisksCauses'),
      role: [roles.role_technological, roles.role_super_admin],
    },
    {
      name: t('potentialRiskTypes.potentialRiskTypes'),
      link: '/potential-risk-types',
      tooltip: t('potentialRiskTypes.potentialRiskTypes'),
      role: [roles.role_super_admin, roles.role_technological],
    },
    {
      name: t('processes.processes'),
      link: '/processes',
      tooltip: t('processes.processes'),
      role: [roles.role_super_admin, roles.role_technological],
    },
    {
      name: t('subprocesses.subprocesses'),
      link: '/subprocesses',
      tooltip: t('subprocesses.subprocesses'),
      role: [roles.role_super_admin, roles.role_technological],
    },
    {
      name: t('revisionTypes.revisionTypes'),
      link: '/revision-types',
      tooltip: t('revisionTypes.revisionTypes'),
      role: [roles.role_super_admin, roles.role_admin,roles.role_head_of_internal_audit],
    },
    {
      name: t('revisionScope.revisionScope'),
      link: '/revision-scope',
      tooltip: t('revisionScope.revisionScope'),
      role: [roles.role_super_admin, roles.role_admin,roles.role_head_of_internal_audit],
    },
    {
      name: t('mitigationRisk.mitigationRisk'),
      link: '/risk-mitigation',
      tooltip: t('mitigationRisk.mitigationRisk'),
      role: [roles.role_technological, roles.role_super_admin],
    },
    {
      name: t('businessLines.businessLines'),
      link: '/business-lines',
      tooltip: t('businessLines.businessLines'),
      role: [roles.role_technological, roles.role_super_admin],
    },
    {
      name: t('typeGainLoss.typeGainLoss'),
      link: '/type-gain-losses',
      tooltip: t('typeGainLoss.typeGainLoss'),
      role: [roles.role_technological, roles.role_super_admin],
    },
    {
      name: t('metodologies.metodologies'),
      link: '/methodologies',
      tooltip: t('metodologies.metodologies'),
      role: [roles.role_technological, roles.role_super_admin],
    },
    {
      name: t('sidebar.codebook'),
      link: '/codebook',
      tooltip: t('sidebar.codebook'),
      role: [roles.role_technological, roles.role_super_admin],
    },
  ];

  return (
    <div className="administration">
      <div className="sidebar-items">
      {isLoaded &&
        navigation.map((item, idx) => (
          <div key={idx}>
            {difUserRoles(item.role) ? (
              <NavLink
                activeClassName="active"
                className="administration-links links reports-tooltip-container"
                to={item.link}
                key={idx}
              >
                <div className="report-text">{item.name}</div>
                {item.name.length > 28 ? (
                  <div className="second-tooltip-text">
                    <span>{item.name}</span>
                  </div>
                ) : (
                  ''
                )}
              </NavLink>
            ) : null}
          </div>
        ))}
        </div>
    </div>
  );
};

export default Administration;
